import fetch from '@/utils/fetch'

export function getTjData (data) {
  return fetch({
    url: '/getTjData',
    data,
    method: 'get'
  })
}

export function getTjDataFh (data) {
  return fetch({
    url: 'https://fh.mathmarch.com/api/serverInfo?token=fiberhome.2019',
    data,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_tj.js